import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthGuard } from "@atenea-cms";
import { PageListComponent } from "./page-list/page-list.component";

const routes: Routes = [
  {
    path: "pages",
    component: PageListComponent,
    canActivate: [AuthGuard],
  },
];

export const PagesRoutes: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/pages/pages.routes.ts